import React, { forwardRef } from 'react';

import {
  Text, Checkbox as ChakraCheckBox, CheckboxProps, Flex, FlexProps, ThemingProps,
} from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useFormState } from 'react-hook-form';

import { handleObjectString } from 'utils/parsers';

interface MyCheckboxProps extends CheckboxProps{
  viewProps?: FlexProps
  fontVariant?: ThemingProps<'Text'>['variant']
}

const Checkbox = forwardRef(({
  fontVariant = 'smallSemiBold', textColor, children, viewProps, name, ...props
}:MyCheckboxProps, ref:any) => {
  let errors = {};

  try {
    const formState = useFormState({
      name,
    });
    errors = formState.errors;
  } catch {
    errors = {};
  }

  const error = !isEmpty(errors) && handleObjectString(errors, name?.split('.')?.[0]);

  return (
    <Flex
      {...viewProps}>
      <ChakraCheckBox
        colorScheme="secondary"
        variant="unstyled"
        isInvalid={!!error}
        ref={ref}
        name={name}
        {...props}
      />
      <Text
        variant={fontVariant}
        color={textColor}
        ml={children && 4}>
        {children}
      </Text>
    </Flex>
  );
});

export default Checkbox;
